module.exports = __webpack_public_path__ + "assets/contentful.b2185aeb.svg";